/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../../components/Navbar";
import PotentialSalesLeadsDashBoard from "../../../components/Payments/Leads";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const PotentialLeadsDashboard = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.payments?.hasLeadsViewAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <PotentialSalesLeadsDashBoard ROOT_URL={ROOT_URL} />
    </>
  );
};

export default PotentialLeadsDashboard;
